<template>
    <font-awesome-icon :icon="['fas', 'spinner']" size="2xl" spin class="text-primary" />
</template>